import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/announcements/")({
  staticData: {
    title: "announcements.title",
  },
});
